import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const edgeSingle178100Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.78,
  key: 'edge_178x100',
  className: 'edge_178x100',
  type: 'Image178x100',
  associationType: 'ImageMedia178X100',
  imagePreviewHeight: 350,
  minimumRequirements: 0,
  minSize: [624, 350],
  localizedText: {
    previewTypeStringKey: _TL_('Microsoft Edge single carousel'),
    stringKey: _TL_('1.78:1'),
    disclaimerMessage: _TL_('This is an example of how your ad could appear on other websites on the Microsoft Advertising Network. The final ad format is likely to change to match the look and feel of the website.'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: true,
    showBusinessName: true,
    showImage: true,
    showShortHeadline: true,
    showGradient: true,
    showShortHeadlineMultiline: true,
    showUrlMultiline: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    businessNameWithAds: {
      '& .business-name': {
        fontSize: 11,
        lineHeight: '1.364',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .adslabel': {
        fontSize: 10,
        lineHeight: '1.364',
        margin: '0 5px 0 0',
        background: 'transparent',
        borderRadius: 4,
        color: '#fff',
        fontFamily: '"Segoe UI","Segoe WP",Arial,Sans-Serif',
        fontWeight: 400,
        padding: '.8px 4px',
        border: '.5px solid hsla(0,0%,100%,.3)',
        opacity: 0.7,
      },
    },
    shortHeadline: {
      color: 'white',
      height: 73,
      fontSize: 28,
      lineHeight: '33.99px',
      width: 590,
      marginBottom: 20,
      '& .multi-line-processed-text': {
        position: 'absolute',
        bottom: 30,
      },
    },
    previewContent: {
      '&:hover': {
        '& .short-headline': {
          textDecoration: 'underline',
        },
      },
      width: 624,
      height: 350,
    },
    textContainer: {
      position: 'absolute',
      color: '#bebebe',
      bottom: 25,
      left: 20,
      fontSize: 10,
      lineHeight: '16px',
    },
    gradient: {
      '&:after': {
        display: 'block',
        position: 'relative',
        backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
        marginTop: -250,
        height: 280,
        width: '100%',
        content: '\'\'',
      },
    },
  },
};

export default edgeSingle178100Raw;
